import { render, staticRenderFns } from "./HomePostersPaginationComponent.vue?vue&type=template&id=4ccce2af"
import script from "./HomePostersPaginationComponent.vue?vue&type=script&lang=js"
export * from "./HomePostersPaginationComponent.vue?vue&type=script&lang=js"
import style0 from "./HomePostersPaginationComponent.vue?vue&type=style&index=0&id=4ccce2af&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports